import dateFormat from "dateformat";

export default {
    data()
    {
        return {
            dayNames: [ "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag", "Zondag" ],
            monthNames: [
                "januari",
                "februari",
                "maart",
                "april",
                "mei",
                "juni",
                "juli",
                "augustus",
                "september",
                "oktober",
                "november",
                "december"
            ],
        }
    },
    methods: {
        formatDayDateMonthYear(date)
        {
            return this.dayNames[date.getDay() - 1] + " " + date.getDate() + " " + this.monthNames[date.getMonth()] + " " + date.getFullYear();
        },
        formatDateMonthYear(date)
        {
            return (date.getDate() + " " + this.monthNames[date.getMonth()] + " " + date.getFullYear());
        },
        formatHourMinutes(date)
        {
            return date.getHours() + ":" + (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();
        },
        getMonthName(date)
        {
            return this.monthNames[date.getMonth()];
        },

        apiDateFormat(date)
        {
            return dateFormat(date, "yyyy-mm-dd");
        },

        formatDate(date)
        {
            return dateFormat(date, "dd-mm-yyyy");
        },
        formatDateTime(date)
        {
            return dateFormat(date, "dd-mm-yyyy h:MM");
        }
    }
}